module.exports = __webpack_public_path__ + "img/file_r2.ae6d6147.png";